<template>
  <div>
    <v-form ref="formEvaluacionPregunta" lazy-validation>
      <v-row dense v-for="(item, index) in listProgramacion" :key="item.id">
        <v-col cols="12">
          <v-card elevation="0">
            <v-card-title>
              <v-row dense>
                <v-col
                  v-if="
                    index == listProgramacion.length - 1 &&
                    listProgramacion.length > 1
                  "
                  cols="12"
                >
                </v-col>
                <v-col v-if="index == 0" cols="12" class="text-subtitle-2">
                  <v-icon small>fa-check</v-icon> Seleccione la competencia,
                  capacidades y desempeño a utilizar en la programación de
                  evaluación
                </v-col>
              </v-row>
            </v-card-title>
            <v-card-text>
              <v-row dense>
                <v-col cols="12">
                  <v-card outlined>
                    <v-card-title class="d-flex justify-center text-subtitle-2">
                      Leyenda
                    </v-card-title>
                    <v-card-text>
                      <v-row>
                        <v-col cols="12" class="d-flex justify-center">
                          <div class="leyenda-comptencia mx-2"></div>
                          Competencia
                          <div class="leyenda-capacidad mx-2"></div>
                          Capacidades
                          <div class="leyenda-desempeno mx-2"></div>
                          Desempeños
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>

                <v-col cols="auto">
                  <v-chip label small>
                    <b>Área: </b>&nbsp; {{ item.desc_area }}
                  </v-chip>
                </v-col>
                <v-col cols="auto">
                  <v-chip label small>
                    <b>Unidad: </b>&nbsp; {{ item.nombre_tema }}
                  </v-chip>
                </v-col>
                <v-col cols="auto">
                  <v-chip label small>
                    <b>Tema: </b>&nbsp; {{ item.nombre_clase }}
                  </v-chip>
                </v-col>
                <v-col cols="12">
                  <v-card outlined>
                    <v-card-title class="text-subtitle-2">
                      Competencias
                      <!-- <pre>Indicadores: {{ Indicador }} </pre> -->
                      <!-- {{ radioGroup }} -->
                    </v-card-title>
                    <v-card-text>
                      <v-row
                        class="competencia white--text"
                        dense
                        v-for="(competencia, indexCompetencia) in item.contenido_indicadores" :key="indexCompetencia">
                        <v-col cols="1" class="d-flex justify-center align-center">
                  
                          <v-radio-group v-model="radioGroup[index]">
                            <v-radio
                              :value="competencia.id_competencia"
                              @change="EventCompetencia(
                                  competencia.id_competencia,
                                  index,
                                  indexCompetencia,
                                  item.id,
                                  competencia.capacidades
                                )"
                              dark>
                              ></v-radio>
                          </v-radio-group>
                        </v-col>

                        <v-col cols="11" class="d-flex justify-start align-center">
                          <div>
                            <v-icon left small color="red">
                              fas fa-chevron-right fa-lg
                            </v-icon>
                            {{ competencia.desc_competencia }}
                            <!-- {{ competencia.desc_competencia + ' --------------- idcomp: ' + competencia.id_competencia }} -->
                          </div>
                        </v-col>

                       <v-col cols="12" v-if="radioGroup[index] == competencia.id_competencia">
                          <v-card outlined>
                            <v-card-title class="text-subtitle-2">
                              Capacidades
                              <!-- {{ capacidadesCheck }} -->
                            </v-card-title>
                            <v-card-text>
                              <v-row                               
                                dense
                                class="capacidades white--text"
                              >
                                <v-col cols="12">
                                  <v-row dense v-for="(capacidad, indexCapacidad) in competencia.capacidades" :key="indexCapacidad">
                                    <v-col cols="1" class="d-flex justify-center align-center">
                                      <!-- :value="+(`${item.id}${capacidad.id_capacidad}`)" -->
                                      <v-checkbox dark :value="Number(item.id+''+capacidad.id_capacidad)" v-model="capacidadesCheck" @change="
                                      EventCapacidad(
                                          capacidad.id_capacidad,
                                          index,
                                          indexCompetencia,
                                          indexCapacidad,
                                          item.id,
                                          capacidad.indicadores
                                          )">
                                      </v-checkbox>
                                    </v-col>
                                    <v-col
                                      cols="11"
                                      class="d-flex justify-start align-center"
                                    >
                                      <div>
                                        <v-icon left color="green">
                                          fas fa-caret-right fa-lg
                                        </v-icon>
                                        {{ capacidad.desc_capacidades }}
                                        <!-- {{ capacidad.desc_capacidades + ' --------------- idcap: ' + capacidad.id_capacidad }} -->
                                        <!-- + ' --------------- idcap: ' + capacidad.id_capacidad -->
                                      </div>
                                    </v-col>
                                    <!-- AQUI VAN LOS DESEMPEÑOS DOM -->
                                    <v-col cols="12" v-if="capacidadesCheck.includes(+(`${item.id}${capacidad.id_capacidad}`))">
                                      <v-card>
                                        <v-card-title class="text-subtitle-2">
                                          Desempeños
                                          <!-- {{ indicadoresCheck }} -->
                                        </v-card-title>
                                        <v-card-text>
                                          <v-row
                                            class="desempeno"
                                            dense
                                            v-for="(indicador, indexIndicador) in capacidad.indicadores" :key="indexIndicador"
                                          >
                                            <v-col
                                              cols="1"
                                              class="d-flex justify-center align-center"
                                            >
                                              <v-checkbox
                                                v-model="indicadoresCheck"
                                                :value="Number(`${item.id}${indicador.id_indicador}`)"
                                                @change="
                                                  EventIndicador(
                                                    competencia,
                                                    capacidad,
                                                    indicador,
                                                    item.id
                                                  )">
                                              </v-checkbox>
                                            </v-col>
                                            <v-col
                                              cols="11"
                                              class="d-flex justify-start align-center"
                                            >
                                              <v-icon small left color="primary">
                                                fas fa-angle-double-right fa-lg
                                              </v-icon>
                                              {{ indicador.desc_indicadores  }}
                                              <!-- {{ indicador.desc_indicadores  + ' --------------- idcap: ' + indicador.id_indicador  }} -->
                                              <!-- + ' --------------- idcap: ' + indicador.id_indicador -->
                                            </v-col>
                                          </v-row>
                                        </v-card-text>
                                      </v-card>
                                    </v-col>
                                  </v-row>
                                </v-col>
                              </v-row>
                            </v-card-text>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                  <!-- {{ capacidad.indicador }} -->
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>   
          <TableButtonComp
                normalButton
                @click="nextStep()"
                textButton="Siguiente"
                iconBut=""
                class="float-right"
              />              
    </v-form>
  </div>
</template>
<script>
import axios, { API_URL } from "@/helpers/axios";
import { mapMutations, mapGetters, mapActions } from "vuex";
import TableButtonComp from "../../../../../components/ComponentsEst/TableButtonComp.vue";

export default {
  name: "evaluacionCompetencias",
  components: { TableButtonComp },
  props: {
    parametros: {
      type: Object,
    },
    estadoComp: {
      type: Boolean,
    },
    estadoValidacion: {
      type: Boolean,
    },
    wizardChange: {
      type: Number,
    },
  },
  data: () => ({
    paramComponente: { id_modulo: 8, id_submodulo: 96 }, //sud_modulo y modulo
    indexC: null,
    // radioGroup: [],
    radioGroup: {},
    datoLogin: sessionStorage, // variables de sesion del usuario
    ruta_api: API_URL, // ruta del servidor
    test: false,
    tabIndex: 2,
    evento: null,
    data: [],
    filtro: {},
    title: "Competencias Programadas",
    listProgramacion: [],
    Indicador: [],
    capacidadesCheck: [],
    indicadoresCheck: [], 
  }),
  mounted() {
    // setTimeout(() => {
      this.LoadMain();
    // }, 1000);

  },
  computed: {
    ...mapGetters("login", ["componenteEvento"]),
  },
  filters: {
    quitarTag: function (string) {
      return string.replace(/<\/?[^>]+>/gi, " ");
    },
  },
  watch: {
    estadoComp(flag) {
      if (flag) {
        this.LoadMain();
      } else {
        this.limpiarForm
      }
    },
    estadoValidacion(flag) {
      if (flag) {
        this.validacionCompetencias();
      }
    },
    wizardChange(step) {
      if (step == 3) {
        this.filtro.id_usuario = parseInt(this.datoLogin.id, 10);
        this.filtro.evento = this.evento;
        this.filtro.id_us_ing = parseInt(this.datoLogin.id, 10);
        this.filtro.fec_us_ing = new Date(Date.now()).toISOString();
        let params = { datos: this.filtro, indicador: this.Indicador };

        this.setlistaCompetencias(params);
      }
    },
  },
  methods: {
    ...mapMutations({
      setEnviarMens: "mensajeSis/setEnviarMens",
      setlistaCompetencias: "gestEvaluacion/setlistaCompetencias",
    }),

    ...mapActions({
      parametroComponente: "login/parametroComponente",
      validateForm: "gestEvaluacion/validateForm",
    }),
    /** 
     ___________________________________________
    |          MÉTODO CARGAR INICIAL          */
    LoadMain() {

      this.listProgramacion = [];
      this.GetQuery();    

      this.filtro.id_programacion = this.parametros.items.id_programacion;
      this.filtro.id_prog_docente = this.parametros.items.id_programacion;
      this.filtro.id_colegio = parseInt(this.parametros.items.id_colegio, 10);
      this.filtro.id_nivel = parseInt(this.parametros.items.id_nivel, 10);
      this.filtro.id_grado = parseInt(this.parametros.items.id_grado, 10);
      this.filtro.id_area = parseInt(this.parametros.items.id_area, 10); 

      this.evento = this.parametros.evento;

      if (this.parametros.evento == "add") {
        this.AddItem();
      } else if (this.parametros.evento == "edit") {
        this.EditItem();
      }
    },
    /** 
     _______________________________________________
    |          MÉTODO OBTENER CURRICULOS          */
    async GetQuery() {
      try {
        let resp = await axios.get(
          `/administrativo/curriculo/list/cr/colegio/${this.datoLogin.id_colegio}/anoLectivo/${this.datoLogin.id_ano_lectivo}`
        );
        let valorFiltro = resp.data;
        let result = valorFiltro.find((element) => (element.status = 1));
        if (result) {
          this.filtro.id_curriculo = result.id;
        } else {
          this.setEnviarMens({
            tipo: "W",
            mensaje: `No existe un curriculo asociado activo al año lectivo `,
            tiempo: 6000,
          });
        }
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },
    /** 
     _________________________________________________
    |          MÉTODO OBTENER PROGRAMACION          */
    async GetProgramacion(id_programacion) {
      try {
        let params = { id_programacion };

        let {data} = await axios.post(`/academico/progDocente/allCompetencias`, {
          filter: params,
        });             
 
        this.listProgramacion = data;

      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },
    /** 
     _______________________________________________________________________________________________________________
    |          MÉTODO COMPETENCIAS PROGRAMACION - listar las  CAPACIDADES a dar click en una Competencia          */
    async EventCompetencia(
      id_competencia,
      indexPrincipal,
      indexComp,
      idprog,
      datosCapacidades
    ) {
  
        datosCapacidades.map((capacidad)=>{
            this.capacidadesCheck = this.capacidadesCheck.filter(item => !item.toString().includes(idprog));
            // eslint-disable-next-line no-unused-vars
            capacidad.indicadores.map((indicador)=>{
              this.indicadoresCheck = this.indicadoresCheck.filter(item => !item.toString().includes(idprog))
              
                this.Indicador = this.Indicador.filter(item => {
                  return item.id_prog_docente[0] != idprog
                });
              })
        })
        this.validacionCompetencias();

    },
    /** 
     ________________________________________________________________________________________________________
    |  MÉTODO COMPETENCIAS PROGRAMACION - listar las INDICADORES O DESEMPEÑO  a dar click en una Capacidad */
    async EventCapacidad(
      id_capacidad,
      indexPrincipal,
      indexComp,
      indexCap,
      idprog,
      datosIndicadores
    ) {  

      if (!this.capacidadesCheck.includes(+(`${idprog}${id_capacidad}`))) { //DISCHECK CAPACIDAD
        datosIndicadores.map((indicador)=>{

            this.indicadoresCheck = this.indicadoresCheck.filter(item => item !== +(`${idprog}${indicador.id_indicador}`));

              this.Indicador = this.Indicador.filter(item => item.id_indicador != indicador.id_indicador && item.id_prog_docente[0] != idprog ); 
 
          })
        this.validacionCompetencias();
      }
    },
    /** 
     ______________________________________________________________
    |          MÉTODO VALIDAR SELECCION DE COMPETENCIAS          */
    validacionCompetencias(){

      const isValid = this.filtro.id_programacion.every(b =>
      this.indicadoresCheck.some(a => a.toString().startsWith(b.toString()))
      );

      this.validateForm({ index: 2, value: isValid });

    },
    /** 
     ___________________________________________________________________________________________
    |  MÉTODO COMPETENCIAS PROGRAMACION - listar las INDICADORES a dar click en una Desempeño */
    EventIndicador(competencia, capacidades, indicador, idprog) {

      if (this.indicadoresCheck.includes(+(`${idprog}${indicador.id_indicador}`))) {

        let items = {
          id_competencia: competencia.id_competencia,
          id_capacidad: capacidades.id_capacidad,
          id_indicador: indicador.id_indicador,
          origin: null,
          id_prog_docente: [idprog],
        };
        this.Indicador.push(items);

      } else {

        let index = this.Indicador.findIndex(
          (item) =>
            item.id_indicador == indicador.id_indicador &&
            item.id_prog_docente[0] == idprog
        );
        this.Indicador.splice(index, 1);

      }
      
      this.validacionCompetencias();

    },
    /** 
     _________________________________________________
    |          MÉTODO OBTENER PROGRAMACION          */
    async nextStep() {
      this.validacionCompetencias();
      this.filtro.id_usuario = parseInt(this.datoLogin.id, 10);
      this.filtro.evento = this.evento;

      let params = { datos: this.filtro, indicador: this.Indicador };

      this.setlistaCompetencias(params);
      this.$emit("wizardNext", 3);
    },
    /** 
     ________________________________________________
    |          MÉTODO CERRAR MODAL O COMP          */
    closeModal() {
      //ViewBancoPreguntaMod
      this.estadoModalConfig = false;
      this.LoadMain();
    },
    /** 
     ______________________________________________________
    |          MÉTODO LIMPIAR FORM COMPETENCIAS          */
    LimpiarForm() {
      this.capacidadesCheck = [],
      this.indicadoresCheck = [],
      this.Indicador = [];
      this.radioGroup = {};
      this.$refs.formEvaluacionPregunta.resetValidation();
      this.validateForm({ index: 2, value: true });
    },
    /** 
     ________________________________________________
    |          MÉTODO EDITAR COMPETENCIAS          */
    AddItem() {
      this.LimpiarForm();
      this.GetProgramacion(this.filtro.id_programacion);
    },
    /** 
     ________________________________________________
    |          MÉTODO EDITAR COMPETENCIAS          */
    async EditItem() { 
      // this.LimpiarForm();
      this.capacidadesCheck = [];
      this.indicadoresCheck = [];
      let progArray = [];
      let competenciasArray = [];

      try {      
        const idevaluacion = this.parametros.items.id;
        if (!idevaluacion) return false;
        
        let {data} = await axios.get(
          `/administrativo/competencia/cargarCompetenciasEval/${idevaluacion}`
        );   

        if (data) {
          this.Indicador = data;
          data.map(e => {
              if (!progArray.includes(+(`${e.id_competencia}${e.id_prog_docente[0]}`))) {
                progArray.push(+(`${e.id_competencia}${e.id_prog_docente[0]}`));
                competenciasArray.push(e.id_competencia);            
              }
              if (!this.capacidadesCheck.includes(+(`${e.id_prog_docente[0]}${e.id_capacidad}`))) {
                this.capacidadesCheck.push(+(`${e.id_prog_docente[0]}${e.id_capacidad}`));              
              }
              if (!this.indicadoresCheck.includes(+(`${e.id_prog_docente[0]}${e.id_capacidad}`))) {
                this.indicadoresCheck.push(+(`${e.id_prog_docente[0]}${e.id_indicador}`));
              }

          });

          competenciasArray.forEach((value,index) => {
              this.radioGroup[index.toString()] = value;
          });

          await this.GetProgramacion(this.filtro.id_programacion);
        }

      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
<style>
.separarProg {
  border-width: 2px;
  border: 3px dashed #bdbdbd;
}

.v-input.classCap .v-messages {
  display: none;
}
</style>
